<template>
  <div class="detail-page">
    <!-- Top gradient header section -->
    <div style="background: linear-gradient(90deg, rgb(252, 120, 175), rgb(242, 38, 120)); border-radius: 0px 0px 20px 20px; overflow: hidden;">
      <!-- Navigation bar (transparent over gradient) -->
      <van-nav-bar left-arrow @click-left="onClickLeft" class="header-nav">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
      <!-- Profile section -->
      <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 90%; margin: 0 auto; padding: 0 0 20px;">
        <div style="border-radius: 10px; overflow: hidden; width: 120px; height: 120px; flex-shrink: 0;">
          <img :src="data.img_url ? data.img_url[0] : ''" style="object-fit: cover; width: 100%; height: 100%;" />
        </div>
        <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column; padding-left: 1rem; flex: 1 1 0%;">
          <p style="color: rgb(255, 255, 255); font-size: 17px; margin: 0; line-height: 1.5;">
            {{ data.xuanfei_name ? (data.xuanfei_name.length > 3 ? data.xuanfei_name.substring(0, data.xuanfei_name.length - 3) : data.xuanfei_name) : '' }}
            <span style="margin-left: 6px; color: rgb(250, 154, 10); font-size: 13px; font-weight: 600;">{{ data.id }}</span>
          </p>
          <div style="height: 28px; margin-top: 4px;">
            <img src="/img/home/rz.png" alt="" style="width: 62px; height: 28px;" />
          </div>
        </div>
      </div>
    </div>

    <!-- Main info section -->
    <div class="feiziInfo">
      <div class="topInfo">
        <!-- Photo Display header -->
        <div>
          <span>{{ $t('member.photo_display') }}</span>
        </div>
        <!-- Photo gallery (horizontal scroll) -->
        <div class="imgswiper">
          <div
            v-for="(img, index) in (data.img_url || [])"
            :key="index"
            style="width: 178px; height: 184px; margin-right: 10px; flex-shrink: 0;"
          >
            <div style="width: 178px; height: 184px;">
              <img
                :src="img"
                class="van-image__img"
                style="object-fit: cover; width: 100%; height: 100%;"
              />
            </div>
          </div>
        </div>
        <!-- Girl Profile section -->
        <div style="padding: 15px 0px; font-size: 16px;">{{ $t('member.girl_profile') }}</div>
        <div style="width: 100%;"></div>
        <!-- Height (hidden by default on target) -->
        <div style="color: rgb(107, 34, 179); font-size: 3vw; margin: 10px 0px; line-height: 32px; display: none;">
          {{ $t('index.height') }}:{{ data.hight }}
        </div>
        <!-- Experience satisfaction with rating -->
        <div>
          <span style="color: rgb(107, 34, 179); font-size: 14px;">{{ $t('member.experience_satisfaction') }}</span>
          <van-rate v-model="data.number" readonly color="#ffd21e" size="18px" />
        </div>
        <!-- Residence -->
        <div style="color: rgb(107, 34, 179); font-size: 14px; margin: 4px 0px; line-height: 32px;">
          {{ $t('index.residence') }}：{{ data.address }}
        </div>
        <!-- Real Person Video (hidden) -->
        <div style="padding: 15px 0px; font-size: 16px; display: none;">{{ $t('index.video') }}</div>
        <div class="movie-video" style="margin: 10px;"></div>
        <!-- Dating Instructions -->
        <h4 style="margin-top: 20px;">{{ $t('member.dating_instructions') }}</h4>
        <p style="padding: 0.66667rem 0px; color: rgb(40, 33, 31);">
          {{ $t('member.dating_note') }}
        </p>
      </div>
    </div>
    <!-- Contact customer service button (inline style to bypass postcss px-to-vw) -->
    <div
      style="background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); position: fixed; bottom: 10px; color: rgb(255, 255, 255); width: 70%; height: 32px; border-radius: 10px; margin-left: 15%; font-size: 16px; line-height: 32px; text-align: center; z-index: 999; cursor: pointer;"
      @click="contactCustomerService"
    >
      {{ $t('member.contact_customer_service') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id },
      }).then(res => {
        this.data = res.data;
        if (this.data.flag) {
          const parts = this.data.flag.split('|');
          const lanng = localStorage.getItem('lang');
          if (lanng === 'zh') this.data.flag = parts[0];
          else if (lanng === 'en') this.data.flag = parts[1];
          else if (lanng === 'ja') this.data.flag = parts[2];
          else this.data.flag = parts[3] || parts[0];
          this.data.flagArray = this.data.flag.split('，');
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    contactCustomerService() {
      this.$router.push('/ServiceOnline').catch(() => {});
    },
  },
  created() {
    this.getxuanfeidata();
  },
};
</script>

<style scoped lang="less">
.detail-page {
  width: 100%;
  min-height: 100vh;
  background: url('/img/home/g.png') center top / 100% repeat;
  background-color: #f5f5f5;
  padding-bottom: 4.33333rem;
}
.header-nav {
  background: transparent !important;
  background-color: transparent !important;
}
.header-nav .van-icon {
  color: #fff !important;
}
::v-deep .header-nav .van-nav-bar__content {
  height: 13.333vw;
  background: transparent !important;
}
.feiziInfo {
  background: #fff;
  padding: 0 15px;
}
.topInfo {
  position: relative;
  padding: 4vw 15px;
  background: #fff;
}
.topInfo > div:first-child span:first-child {
  color: #2c1868;
  font-size: 5vw;
  font-weight: bold;
}
.imgswiper {
  width: 100%;
  overflow-x: auto;
  margin: 4vw 0;
  display: flex;
  flex-wrap: nowrap;
}
.imgswiper::-webkit-scrollbar {
  display: none;
}
.movie-video {
  display: none;
}
h4 {
  color: #2c1868;
  font-size: 16px;
  font-weight: bold;
}
</style>
